import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    defauitDeviceType: null, // 默认设备组类型
    setNavMenu: "", // 左边菜单栏状态
    gradesInfo: "", //班级管理状态数据
    classInfo: "", //班级id
    chageType: "", //首页选择的学校和年级
    //在创建学校之后默认创建的年级
    grades: [
      { grade_name: "一年级", grade_sort: 0 },
      { grade_name: "二年级", grade_sort: 1 },
      { grade_name: "三年级", grade_sort: 2 },
      { grade_name: "四年级", grade_sort: 3 },
      { grade_name: "五年级", grade_sort: 4 },
      { grade_name: "六年级", grade_sort: 5 }
    ],
    schoolInfo: {},
    chooseSchool: false,
    time: 10,
    gradeIndex: 0, // 选择的年级index\
    fullscreen: false // 全屏
  },
  mutations: {
    DEFAUITDEVICETYPE(state, data) {
      state.defauitDeviceType = data;
    },
    CHOOSESCHOOL(state, data) {
      state.chooseSchool = data;
    },
    SCHOOLINFO(state, data) {
      state.schoolInfo = data;
    },
    gradeIndex(state, data) {
      state.gradeIndex = data;
    },
    setNavMenu(state, data) {
      state.setNavMenu = data;
    },
    gradesInfo(state, data) {
      state.gradesInfo = data;
    },
    classInfo(state, data) {
      state.classInfo = data;
    },
    chageType(state, data) {
      state.chageType = data;
    },
    fullscreen(state, data) {
      state.fullscreen = data;
    }
  },
  actions: {
    schoolInfo({ commit }, data) {
      commit("SCHOOLINFO", data);
    },
    chooseSchool({ commit }, data) {
      commit("CHOOSESCHOOL", data);
    },
    defauitDeviceType({ commit }, data) {
      commit("DEFAUITDEVICETYPE", data);
    }
  },
  modules: {},
  // 持久化缓存 vuex
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js